import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "antd/dist/antd.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./index.css";
import "./App.css";
import App from "./App";
import initHttp from "@/common/http";
import configureStore from "./common/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { setAuthToken } from "./common/auth";
import { setAuthentication } from "./login/ducks";

const { store, persistor } = configureStore();

const token = localStorage.getItem("token");
if (token) {
  store.dispatch(setAuthentication(true));
  setAuthToken(token);
}

initHttp();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
